<template>
  <div class="flex-grow-1 d-flex flex-column overflow-y-hidden">
    <div class="a-header">
      <span class="a-header--title slide-down-enter-active">Policies</span>
      <div class="d-flex">
        <a-button size="large" class="a-header--button slide-down-enter-active mr-2" @click="onBulkEdit">
          <a-icon type="edit" class="mr-2" />
          Bulk Edit
        </a-button>
        <a-button size="large" class="a-header--button slide-down-enter-active" type="primary" @click="onAdd">
          <img class="mr-2 icon-size" src="@assets/icon/plus.svg" />
          Add New
        </a-button>
      </div>
    </div>
    <div class="d-flex justify-content-center align-items-center pt-35-px" v-if="isLoading">
      <Spinner />
    </div>
    <transition name="slide-up">
      <div class="a-filter" v-if="!isLoading">
        <a-row class="full-w" type="flex" justify="start" :gutter="16">
          <a-col :span="5">
            <div class="full-w a-input-group" :class="{ active: !!filterParams.search }">
              <a-button size="large">
                <a-icon type="search" />
              </a-button>
              <a-input class="custom-prefix" placeholder="Search" @change="onSearch"></a-input>
            </div>
          </a-col>
        </a-row>
      </div>
    </transition>
    <div v-resize="elSizeChange" class="a-body flex-grow-1 overflow-y-hidden">
      <transition name="slide-up">
        <template v-if="!isLoading">
          <PaginationTable
            :pagination="pagin"
            :columns="PolicyListColumn"
            :dataSource="filterData"
            :tableSize="tableSize">
            <div slot="urls" slot-scope="{ record }">
              <a v-for="item in record.urls" :key="item.id" class="url d-block text-truncate" :href="item.url">{{ item.url }}</a>
            </div>
            <div slot="create_date" slot-scope="{ record }">
              <p class="mb-0">
                <time>{{ record.create_date | dateString }}</time>
                <br />
                <time>{{ record.create_date | timeString }}</time>
              </p>
            </div>
            <template slot="operation" slot-scope="{ record }">
              <a-dropdown placement="topLeft">
                <a-icon class="operation" type="ellipsis" />
                <a-menu slot="overlay" class="operation-menu">
                  <a-menu-item @click="onEdit(record)"> <a-icon type="edit"></a-icon>Edit </a-menu-item>
                  <a-menu-item>
                    <div class="full-wh" @click="showDeleteConfirm(record)"><img class="mr-2" src="@assets/icon/delete.svg" /> Delete</div>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </template>
          </PaginationTable>
        </template>
      </transition>
    </div>
    <div class="a-footer" v-if="!isLoading">
      <PaginationBar :pageSize.sync="pagin.pageSize" :total="pagin.total" @change="paginChange" />
    </div>
  </div>
</template>

<script>

  import { PAGE_OPTIONS } from '@constants/pageOptions';
  import { PolicyListColumn } from '../columnsTable/PolicyListColumn';
  import PolicyService from '../services/policy.service';

  export default {
    name: 'PolicyList',
    data() {
      let pageSize = Number(window.localStorage.getItem("pageSize"));
      if (!pageSize) {
        pageSize = 5;
      }

      return {
        PAGE_OPTIONS,
        PolicyListColumn,
        data: [],
        filterData: [],
        filterParams: {
          search: ''
        },
        pagin: {
          current: 1,
          pageSize: pageSize,
          total: 0
        },
        isLoading: true,
        tableSize: {
          height: '',
          width: ''
        }
      };
    },
    mounted() {
      this.getList();
    },
    methods: {
      filter() {
        const searchTerm = this.filterParams.search.trim().toLowerCase();
        this.filterData = searchTerm ? this.data.filter((item) => item.name.toLowerCase().includes(searchTerm)) : this.data;
        this.pagin = {
          current: 1,
          pageSize: this.pagin.pageSize,
          total: this.filterData.length
        };
      },
      onAdd() {
        this.$router.push('/policy/add');
      },
      onBulkEdit() {
        this.$router.push('/policy/bulk-rules');
      },
      onDelete(record) {
        PolicyService.delete(record.id).then(() => {
          this.$showSuccessMessage('Deleted Policy');
          this.getList();
        });
      },
      onEdit(record) {
        this.$router.push({
          path: '/policy/' + record.id
        });
      },
      onSearch(event) {
        this.filterParams.search = event.target.value;
        this.filter();
      },
      paginChange(pagin) {
        this.pagin = { ...pagin };
      },
      async getList() {
        try {
          const data = await PolicyService.getList();
          this.data = [...(data || [])].map((item, index) => ({
            ...item,
            index: index + 1,
          }));
          this.filter();
        } catch {
          this.$showErrorMessage('HTTP error received from web server.!');
        } finally {
          if (this.isLoading) {
            setTimeout(() => {
              this.isLoading = false;
            }, 300);
          }
        }
      },
      showDeleteConfirm(record) {
        this.$confirm({
          title: 'Are you sure delete this item?',
          okText: 'Yes',
          okType: 'danger',
          cancelText: 'No',
          onOk: () => {
            this.onDelete(record);
          }
        });
      },
      elSizeChange(size) {
        this.tableSize = size;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .url {
    display: block;
  }
</style>
